import React from 'react';
import Link from '../../../../common/components/core/Link';
/*
 * Creates adaptable messages adhering to common fields. Used for conditional rendering
 * and error display. Should be moved to separate file.
 *
 * @param {string} key - default unique key for react to render with
 * @return {MessageFactory} new instance of class that have methods to create plain object messages
 */
var MessageFactory = function (key) {
  this.defaultProperties = { key };
  /*
   * MessageFactory#prototype#createError function to overload defaultProperties object
   * @param {string} text - Primitive string or jsx html to be rendered with
   * @return {object}     - Data representing the error
   */
  this.createError = (text) => ({
    ...this.defaultProperties,
    type: 'error',
    required: true,
    text,
  });

  /*
   * MessageFactory#prototype#createSuccess function to overload defaultProperties object
   * @param {string} text - Primitive string or jsx html to be rendered with
   * @return {object}     - Data representing the success
   */
  this.createSuccess = (text) => ({
    ...this.defaultProperties,
    type: 'success',
    text,
  });

  this.createWarning = (text, options) => ({
    ...this.defaultProperties,
    type: 'warning',
    text,
    ...options,
  });

  /*
   * MessageFactory#prototype#createFailure when platform compatibility collides with what views they have
   * @param {string} rule_id - Jsx html with link to AMP documentation to be rendered with
   * @param {object} options - Options object to specify required, frequency
   * @return {object}     - Data object that sentries them from saving/starting journey
   */
  this.createFailure = (rule_id, options) => {
    const textSpan = (
      <span>
        Your Journey targets AMP Web users but the selected template(s) are not AMP-compatible.{' '}
        <Link to={`/journeys/audiencerule/customize/${rule_id}`} testid="not-amp-compatible_change-views">
          Change Views
        </Link>
        .
      </span>
    );
    return { ...this.createError(textSpan), ...options };
  };

  /*
   * MessageFactory#prototype#createValid when platforms are good to go with views
   * @param {string} rule_id - Jsx html with link to AMP documentation to be rendered with
   * @param {object} options - Options object to specify required, frequency
   * @return {object}     - Data object that sentries them from saving/starting journey
   */
  this.createValid = (rule_id, options) => {
    const textSpan = (
      <span>
        Selected template(s) are AMP-compatible.{' '}
        <Link to={`/journeys/audiencerule/customize/${rule_id}`} testid="amp-compatible__change-views">
          Change Views
        </Link>
        .
      </span>
    );
    return { ...this.createSuccess(textSpan), ...options };
  };
};

export default MessageFactory;
